import { render, staticRenderFns } from "./PageParts.vue?vue&type=template&id=21dd1d57&"
import script from "./PageParts.vue?vue&type=script&lang=js&"
export * from "./PageParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21dd1d57')) {
      api.createRecord('21dd1d57', component.options)
    } else {
      api.reload('21dd1d57', component.options)
    }
    module.hot.accept("./PageParts.vue?vue&type=template&id=21dd1d57&", function () {
      api.rerender('21dd1d57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/PageParts.vue"
export default component.exports